export const getCollectionId = (state) =>
  state.addMoreProductsModal.collectionId
export const getSearchText = (state) => state.addMoreProductsModal.searchText
